import React from 'react';
import classnames from 'classnames';
import { Card } from 'react-bootstrap';
import CreateSearchButton from 'v2/common/CreateSearchButton/CreateSearchButton';
import styles from './featuredDataProvidersList.module.scss';
import { FeaturedDataProvider, FeaturedDataProviderStatus } from 'v2/models';
import { useMutation, useQueryClient } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { toast } from 'react-toastify';
import { ReactComponent as CheckSVG } from 'v2/icons/checkIconFilled.svg';
import { fetchPermissionsAction } from 'actions';
import { connect } from 'react-redux';
import { useInvalidateSearchCounts } from 'v2/queries/searches/useInvalidateSearchCounts';

interface StateProps {
  item: FeaturedDataProvider;
}

export const buttonTitles: Record<FeaturedDataProviderStatus, string> = {
  already_in_drm: 'Already in DRM',
  data_requested: 'Data Requested',
  submitted_by_other: 'Data Requested by colleague',
  request_data: 'Request Data',
};

interface DispatchProps {
  fetchPermissionsAction: () => void;
}

type FeatureDataProviderCardProps = StateProps & DispatchProps;

const FeatureDataProviderCard = ({
  item,
  fetchPermissionsAction,
}: FeatureDataProviderCardProps) => {
  const queryClient = useQueryClient();
  const invalidateSearchCounts = useInvalidateSearchCounts();

  const { mutate: createRequest, isLoading } = useMutation(
    async () => {
      const headers = {
        'Content-Type': 'application/json',
      };
      return await restFactory.post(
        `/dj/api/v1/featured_data_provider/${item.id}/create_request/`,
        {},
        headers
      );
    },
    {
      onSuccess: () => {
        fetchPermissionsAction();
        invalidateSearchCounts();
        queryClient.invalidateQueries('fetching_featured_data_provider_data');
        toast.success('Request created.');
      },
      onError: () => {
        toast.error('Error creating request.');
      },
    }
  );

  return (
    <Card className={classnames(styles.card)}>
      <Card.Body className={classnames(styles.rowBody)}>
        <div className={classnames(styles.tableRow, styles.columnStyle)}>
          <p className="text-primary-dark font-weight-bold">
            {item.data_category}
          </p>
          <p className="text-primary-dark mr-5 pr-5">{item.use_case}</p>

          {item.provider_status === FeaturedDataProviderStatus.request_data ? (
            <CreateSearchButton
              featureProviderHandler={createRequest}
              featuredProviderMode
              disabled={isLoading}
            />
          ) : (
            <button
              className={classnames('btn', {
                [styles.isInDRM]: item.provider_status === 'already_in_drm',
              })}
              disabled
            >
              {item.provider_status !== 'already_in_drm' && (
                <div className="w-20">
                  <CheckSVG width={14} height={14} />
                </div>
              )}
              {buttonTitles[item.provider_status]}
            </button>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

export default connect<StateProps, DispatchProps>(null, {
  fetchPermissionsAction,
})(FeatureDataProviderCard);
